import DashboardFilters from "../_dashboard-filters";
import StatesFilter from "./states/filter";
import StatesTable from "./states/table";
import AlertsTable from "./alerts/table";
import AlertsFilter from "./alerts/filter";
import TechnicalStatusTable from "./technical-status/table";
import TechnicalStatusFilter from "./technical-status/filter";
import DashboardChart from "./chart";
import { AlertTypes } from "../../constants/alert_types";
import { mapActions, mapState } from "vuex";
import store from "@/plugins/store/store";
import i18n from "../../plugins/i18n";
import { StatusTypes } from "../../constants/status_types";
import { AlertStatuses } from "../../constants/alert_statuses";
import { TechnicalStatuses } from "../../constants/technical_statuses";

const tabs = [
  {
    key: StatusTypes.States,
    name: i18n.t("dashboardView.states.states"),
    filter: StatesFilter,
    table: StatesTable,
    withoutFilter: DashboardChart,
    icon: "action-list/msyst-icon_action-list-white"
  },
  {
    key: AlertTypes.Alerts,
    name: i18n.t("dashboardView.alerts.alerts"),
    filter: AlertsFilter,
    table: AlertsTable,
    icon: "health-status/msyst-icon_health-status-white"
  },
  {
    key: TechnicalStatuses.TechnicalAlerts,
    name: i18n.t("dashboardView.technical.technical"),
    filter: TechnicalStatusFilter,
    table: TechnicalStatusTable,
    icon: "msyst-icon_lorawan-white"
  }
];

export default {
  name: "DashboardNew",
  components: { DashboardFilters },
  data() {
    return {
      selectedTab: tabs[0],
      searchText: "",
      selectedFilter: null,
      tabs
    };
  },
  computed: {
    ...mapState({
      summaries: state => {
        // extend a copy of state with alerts and technicalAlerts totals
        const totals = {};
        totals[AlertTypes.Alerts] = state.alerts.totals[AlertTypes.Heat] +
          state.alerts.totals[AlertTypes.RepeatHeat] +
          // state.alerts.totals[AlertTypes.PossibleMilkFever] +
          state.alerts.totals[AlertTypes.LowWaterIntake] +
          state.alerts.totals[AlertTypes.Calving] +
          state.alerts.totals[AlertTypes.LowTemp] +
          state.alerts.totals[AlertTypes.HighTemp] +
          state.alerts.totals[AlertTypes.IncreasedActivity] +
          state.alerts.totals[AlertTypes.DecreasedActivity];

        totals[AlertTypes.TechnicalAlerts] = state.alerts.totals[AlertTypes.LowCoverage] +
          state.alerts.totals[AlertTypes.OutOfRange] +
          state.alerts.totals[AlertTypes.NetworkFailure];

        totals[StatusTypes.States] = Object.values(state.states.totals).reduce((a, b) => a + b, 0);
        return totals;
      }
    }),
    renderableComponent() {
      if (this.selectedTab.withoutFilter && !this.selectedFilter) {
        return this.selectedTab.withoutFilter;
      }
      return this.selectedTab.table;
    },
    tableTitle() {
      const base = this.selectedTab.name;
      
      if (this.selectedTab.key == AlertTypes.TechnicalAlerts){
        return base + " - Gateway Status"
      }

      if (this.selectedFilter) {
        return base + " - " + this.selectedFilter.name;
      }
      return base;
    }
  },
  methods: {
    ...mapActions("alerts", {
      clearAlerts: "clear",
      getAlerts: "getAlerts",
      getLastHeats: "getLastHeats",
    }),
    ...mapActions("technicalStatuses",{
      getGatewayStatuses: "getGatewayStatuses",
      getCowsNotSeen: "getCowsNotSeen",
      getCowsWithHighPM: "getCowsWithHighPM"
    }),
    ...mapActions("states", {
      getStates: "getStates",
      clearTasks: "clear",
    }),
    ...mapActions("sensorLogs", {
      getLatestSensorLogs: "getLatestSensorLogs"
    }),
    currently_active() {
      if (!this.selectedFilter || !this.selectedFilter.filter)
        return 0;
      return store.state.alerts.totals[this.selectedFilter.filter];
    },

    gatherData(key = null) {
      this.getLatestSensorLogs();

      // Get only Dry statuses
      if (key === "nonLactating") {
        key = StatusTypes.Dry;
      }

      // Get statuses for all cows
      if (key === "allCows") {
        this.getStates({
          totals_only: false,
          with_cow: true,
          with_building: true,
          status_type: [],
          active_only: true,
          with_heat_index: true,
        });
      }

      // Get Non-Dry statuses
      if (key === "lactating") {
        this.getStates({
          totals_only: false,
          with_cow: true,
          with_building: true,
          status_type: [StatusTypes.Cull, StatusTypes.Inseminated, StatusTypes.Pregnant,
          StatusTypes.ReproPeriod, StatusTypes.VoluntaryWaitingPeriod],
          active_only: true,
          with_heat_index: true
        });
      }
      // key null means the main page is loaded
      if (!key || Object.values(StatusTypes).includes(key)) {
        // check if on main dashboard page or we selected a category
        const selected = ![null, StatusTypes.States].includes(key)
        // get statuses for statuses page or totals
        this.getStates({
          totals_only: !selected,
          with_cow: selected,
          with_building: selected,
          status_type: (selected ? [key] : []),
          active_only: true,
          with_heat_index: true
        });
      }
      if(Object.values(TechnicalStatuses).includes(key)){
        if(key === TechnicalStatuses.GatewayStatus){
          this.getGatewayStatuses()
        }
        if(key === TechnicalStatuses.CowsNotSeen){
          this.getCowsNotSeen()
        }
        if(key === TechnicalStatuses.CowsWithHighPm){
          this.getCowsWithHighPM()
        }
      }
      if (!key || Object.values(AlertTypes).includes(key)) {
        // get alerts for alerts page and totals only for main page
        let keys = undefined;
        if (key) {
          if (key == AlertTypes.Alerts) {
            keys = [
              AlertTypes.Heat,
              AlertTypes.RepeatHeat,
              AlertTypes.HighTemp,
              AlertTypes.LowTemp,
              // AlertTypes.PossibleMilkFever,
              AlertTypes.LowWaterIntake,
              AlertTypes.IncreasedActivity,
              AlertTypes.DecreasedActivity,
              AlertTypes.Calving
            ];
          } else {
            keys = [key]
          }
        }
        if (!key) {
          // For alerts totals
          this.getAlerts({
            totals_only: true,
            alert_statuses: [AlertStatuses.active],
          });
          // For technicals totals
          this.getAlerts({
            totals_only: true,
            alert_statuses: [AlertStatuses.active],
            last_3_days: true,
            technicals: true
          });
        } else {
          // For active alerts
          this.getAlerts({
            with_cow: true,
            with_building: true,
            alert_statuses: [AlertStatuses.active],
            alert_types: keys
          });
          // For earlier alerts
          this.getAlerts({
            with_cow: true,
            with_building: true,
            alert_statuses: [AlertStatuses.confirmed, AlertStatuses.dismissed, AlertStatuses.expired],
            alert_types: keys,
            limit: 50
          })
          // For (active alerts) last heats 
          this.getLastHeats()
        }
      }

    },

    /**
     * Set the selected tab
     * @param {object} tab The selected tab representative object
     */
    setTab(tab) {
      this.selectedTab = tab;

      if(tab.key != TechnicalStatuses.TechnicalAlerts){
        this.selectedFilter = null;
      }

      this.gatherData(tab.key);
    },

    /**
     * Set the selected filter
     * @param {object} filter Set the selected filter representative object
     */
    setFilter(filter) {
      if (this.selectedFilter === filter && !Object.values(TechnicalStatuses).includes(filter.filter)) {
        this.selectedFilter = null;
      } else {
        this.selectedFilter = filter;
      }
      this.gatherData(this.selectedFilter && this.selectedFilter.filter);
    }
  },
  mounted() {
    this.gatherData();
  },
  destroyed() {

  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/dashboard.js